export default __webpack_public_path__ + "static/media/fb.ddaa4e4a.svg";